import React from "react";
import styles from "./profile-desc-tab.module.css";
import { LOCALES, MONTH_ENG, UI_TEXT } from "../../../../constants";
import { getUIText } from "../../../../translation";

export default function ProfileDescTab({ lang, savior, isTabActive }) {
    return (
        <div className={`${styles["profile"]} ${styles[isTabActive]}`}>
            <div>
                <strong>{getUIText(lang, "savior.modal.profile.birth")}</strong>
                {/* <span>{getDateText(savior.inst.birth)}</span> */}
                {!savior.inst.birth.month && <span>{savior.inst.birth[lang]}</span>}
                {savior.inst.birth.month && lang === LOCALES.KO && (
                    <span>{`${String(savior.inst.birth.month).padStart(2, "0")}월 ${String(savior.inst.birth.day).padStart(2, "0")}일`}</span>
                )}
                {savior.inst.birth.month && lang === LOCALES.EN && (
                    <span>{`${MONTH_ENG[savior.inst.birth.month]} ${savior.inst.birth.day}`}</span>
                )}
            </div>
            <div>
                <strong>{getUIText(lang, "savior.modal.profile.height")}</strong>
                <span>{savior.inst.height}cm</span>
            </div>
            <div>
                <strong>{getUIText(lang, "savior.modal.profile.origin")}</strong>
                <span>{savior.inst.origin[lang]}</span>
            </div>
            <div>
                <strong>{getUIText(lang, "savior.modal.profile.affiliation")}</strong>
                <span>{savior.inst.team[lang]}</span>
            </div>
            <div>
                <strong>CV (KR)</strong>
                <span>{savior.inst.cv_ko[lang]}</span>
            </div>
            <div>
                <strong>CV (JP)</strong>
                <span>{savior.inst.cv_jp[lang]}</span>
            </div>
        </div>
    );
}
